import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const StartHero = () => {
  return (
    <React.Fragment>
      <>
        <section className="h2_nh_hero-area">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="h2_nh_hero-content pt-35">
                  <span className="h2_nh_hero-content-subtitle">
                    welcome to mitra recharge
                  </span>
                  <h1
                    className="h2_nh_hero-content-title"
                    style={{ fontSize: "45px" }}
                  >
                    Fast, Secure & Hassle-Free Recharges – Anytime, Anywhere!
                  </h1>
                  <p>
                    Get instant Mobile, DTH, and Google Play recharges with
                    Mitra Recharge. Enjoy secure transactions, best commission
                    rates, and 24/7 support – all in one place!
                  </p>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.mitrarecharge.mitrarechargeapp"
                    target="_blank"
                    className="nh_theme-btn"
                  >
                    Download App Now
                  </a>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="h2_nh_hero-img">
                  <img src="/images/bbps_banner.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    </React.Fragment>
  );
};

export default StartHero;
